import * as React from 'react'
import { Typography } from 'cs-kevlar-react'
import { CustomerCertificateViewModel } from '../api'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import { getCustomerCertificateStatusLabel } from 'utils'
import { Grid } from 'cs-kevlar-react'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    key: {
      color: theme.palette.neutralButton.main,
    },
    fingerprint: {
      wordBreak: 'break-all',
    },
  }),
)

interface CertificateHistoryProps {
  certificate: CustomerCertificateViewModel | null
  className?: string
}

export const CertificateHistory: React.FunctionComponent<CertificateHistoryProps> = ({
  certificate,
  className,
}) => {
  const classes = useStyles({})

  const status = certificate
    ? getCustomerCertificateStatusLabel(certificate.status)
    : '--'
  const validFrom = certificate
    ? `${certificate.issuedOn} through ${certificate.expiresOn}`
    : '--'
  const fingerprint = certificate ? certificate.fingerprint : '--'

  return (
    <Grid container className={className}>
      <Grid item xs={4}>
        <Typography variant="body2" display="inline" className={classes.key}>
          Status
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography variant="body2" display="inline">
          {status}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="body2" display="inline" className={classes.key}>
          Valid From
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography variant="body2" display="inline">
          {validFrom}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="body2" display="inline" className={classes.key}>
          Fingerprint
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography
          variant="body2"
          display="inline"
          className={classes.fingerprint}
        >
          {fingerprint}
        </Typography>
      </Grid>
    </Grid>
  )
}
